import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-show-more-or-less-text',
  templateUrl: './show-more-or-less-text.component.html',
  styleUrls: ['./show-more-or-less-text.component.scss']
})
export class ShowMoreOrLessTextComponent implements OnChanges {
  showFlag: boolean = false;
  @Input() isShowMoreLabelShown: boolean = true;
  @Input() text: string = '';
  // ? For texts with some listed elements (eg. news)
  @Input() shownListedElementsLength: number = 0;
  @Input() separator: string = ',';
  // ? For other texts
  @Input() trimmedTextLength: number = 190;
  @Input() maxLines: number = 2;

  public trimmedText: string = '';

  constructor() {
    this.initData(this.text);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.text) {
      this.initData(changes.text.currentValue);
      this.showFlag = false;
    }
  }

  private initData(text: string) {
    if (text) {
      let newText = text;
      const lines = text.split('<br/>');
      if (this.shownListedElementsLength > 0) {
        newText = text.split(this.separator).slice(0, this.shownListedElementsLength).join(this.separator);
        this.trimmedText = newText.length != text.length ? newText + '...' : newText;
      } else if (lines.length > this.maxLines) {
        if (lines[0].length > this.trimmedTextLength * 0.5) {
          newText = lines[0] + '...';
        } else if (lines[1].length > this.trimmedTextLength * 0.5) {
          newText = lines[0] + '<br/>' + lines[1].slice(0, this.trimmedTextLength * 0.5) + '...';
        } else {
          newText = lines[0] + '<br/>' + lines[1] + '...';
        }
      } else if (text.length > this.trimmedTextLength) {
        newText = text.slice(0, this.trimmedTextLength) + '...';
      }
      this.trimmedText = newText;
    } else {
      this.trimmedText = text;
    }
  }
}
